import React, { useMemo } from "react";
import { useSettingsSearch } from "./SettingsSearchContext";
import { sectionMatchesSearch } from "../data/settingsSearchIndex";
import { resolveSettingsNav } from "../data/settingsNavConfig";

export default function SettingsSidebar({
  activeSection,
  onSelect,
  showProgressionAdmin,
  mobileCatalog = false,
}) {
  const { normalizedQuery } = useSettingsSearch();
  const groups = useMemo(
    () => resolveSettingsNav({ showProgressionAdmin }),
    [showProgressionAdmin],
  );

  const visibleGroups = useMemo(() => {
    if (!normalizedQuery) return groups;
    return groups
      .map((group) => ({
        ...group,
        items: group.items.filter((item) =>
          sectionMatchesSearch(item.id, item.title, normalizedQuery),
        ),
      }))
      .filter((group) => group.items.length > 0);
  }, [groups, normalizedQuery]);

  return (
    <aside
      className={`settings-sidebar${mobileCatalog ? " settings-sidebar--catalog" : ""}`}
      aria-label="Settings sections"
    >
      {mobileCatalog ? (
        <div className="settings-catalog-header">
          <h2 className="settings-catalog-title">All settings</h2>
          <p className="settings-catalog-hint">
            Pick a section to open it. Use search above to filter.
          </p>
        </div>
      ) : null}
      <nav className="settings-sidebar-nav">
        {visibleGroups.map((group) => (
          <div key={group.id} className="settings-sidebar-group">
            <div className="settings-sidebar-group-label">{group.label}</div>
            <ul className="settings-sidebar-list">
              {group.items.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className={`settings-sidebar-item${
                      !mobileCatalog && activeSection === item.id
                        ? " is-active"
                        : ""
                    }`}
                    onClick={() => onSelect(item.id)}
                    aria-current={
                      !mobileCatalog && activeSection === item.id
                        ? "page"
                        : undefined
                    }
                  >
                    <span className="settings-sidebar-item-title">
                      {item.title}
                    </span>
                    {mobileCatalog ? (
                      <span className="settings-sidebar-chevron" aria-hidden>
                        ›
                      </span>
                    ) : null}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      {mobileCatalog && visibleGroups.length === 0 ? (
        <p className="settings-catalog-empty">No sections match your search.</p>
      ) : null}
    </aside>
  );
}
